interface Props {
  text?: string;
  isLoading?: boolean;
  disabled?: boolean;
  desktopWidth?: 'full' | undefined;
  shortButtonWidth?: boolean;
  justifyStart?: boolean;
  redBtn?: boolean;
  justifyCenter?: boolean;
  roundCorners?: boolean;
}

const FormSubmitButton = ({
  text = 'Skicka',
  isLoading,
  disabled,
  desktopWidth,
  shortButtonWidth,
  justifyStart,
  justifyCenter,
  redBtn,
  roundCorners,
}: Props): JSX.Element => {
  return (
    <div
      className={`md:flex  w-full ${
        justifyStart === true
          ? 'justify-start'
          : justifyCenter === true
          ? 'justify-center'
          : 'justify-end'
      } `}
    >
      <button
        className={`${
          disabled ? 'bg-grey300 hover:bg-grey300' : ''
        } text-white font-icb py-3 px-5 form-submit-button w-full outline-none ${
          roundCorners ? 'rounded-full' : 'rounded-md'
        } ${desktopWidth === 'full' ? '' : 'md:w-1/2'}  ${
          shortButtonWidth === true ? 'md:w-3/12' : ''
        } ${
          redBtn === true
            ? 'bg-red500 hover-darken-red500'
            : 'bg-blue700 hover-darken-blue'
        } ${roundCorners ? 'rounded-3xl' : 'rounded-md'}`}
        type="submit"
        disabled={disabled}
      >
        {isLoading ? (
          <span className="loading-dot">
            <span className="mr-1">Laddar</span>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </span>
        ) : (
          text
        )}
      </button>
    </div>
  );
};
export default FormSubmitButton;
